import { takeLatest, put, call } from 'redux-saga/effects';
import { storage } from '@commons/storage';

import {
  CONFIG_SESSION,
  NEW_FILTER_CONCILIACAO_BANCARIA,
  NEW_FILTER_CONCILIACAO_BANCARIA_PENDING,
  NEW_FILTER_CONCILIACAO_BANCARIA_SUCCESS,
  NEW_FILTER_CONCILIACAO_BANCARIA_FAILURE,
  findAllContaBancoCadastro,
} from '@handler';
import { formatDateDDMMYYYY, formatDateYYYYMMDD } from '@components/common/format';
import { buscarMovimentacoes, buscarPendentes, buscarIgnoradas } from '../service';
import {
  CONST_ROWS_PER_PAGE_CONCILIACAO,
} from '@commons/consts';

const CONST_FILTER_CONCILIACAO_BANCARIA = 'FILTER_CONCILIACAO_BANCARIA';

// Mapeamento das abas para os endpoints
const endpointMapping = {
  'movimentacoes': buscarMovimentacoes,
  'pendentes': buscarPendentes,
  'ignoradas': buscarIgnoradas,
};

function* sagaNewFilterConciliacaoBancaria(action) {
  try {
    yield put({ type: NEW_FILTER_CONCILIACAO_BANCARIA_PENDING });

    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;
    let datas = '';
    let dataInicial = '';
    let dataFinal = '';
    var date = new Date();
    let where = '';
    let filterSaved = sessionStorage.getItem(CONST_FILTER_CONCILIACAO_BANCARIA) !== null ?
      JSON.parse(sessionStorage.getItem(CONST_FILTER_CONCILIACAO_BANCARIA)) : null;

    let newFilter = {
      contaBanco: null,
      abaAtiva: 'pendentes', // pendentes, movimentacoes, ignoradas
      tipoTransacao: null, // CREDIT, DEBIT ou null para todos
      dataInicial: '',
      dataFinal: '',
      contasCadastro: null,
      rows: filterSaved?.rows || CONST_ROWS_PER_PAGE_CONCILIACAO,
      page: filterSaved?.page || 0,
      where: ''
    };

    // Verifica se precisa inicializar (primeira vez ou não tem conta bancária)
    const needsInitialization = filterSaved === null || filterSaved === undefined ||
                                !filterSaved.contaBanco || !filterSaved.dataInicial || !filterSaved.dataFinal;

    if (needsInitialization) {
      // seta data do mês na primeira vez que entra na página
      dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), 1));
      dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 1, 0));

      datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
      where = '';
      const contasCadastro = yield call(findAllContaBancoCadastro, idFazenda);
      let contaBanco = null;
      if (contasCadastro !== null && contasCadastro !== undefined && contasCadastro.length >= 1) {
        contaBanco = contasCadastro[0];
      }

      newFilter = {
        ...newFilter,
        dataInicial,
        dataFinal,
        contaBanco: contaBanco,
        contasCadastro: contasCadastro,
        where: where
      };
    } else {
      // se seta filtro manual
      if (action.newFilter) {
        // Quando aplica um novo filtro, volta para a primeira página
        // mas mantém o número de registros por página selecionado pelo usuário
        newFilter.page = 0;

        // seta filtro indicado
        // typePeriodo = 0 -> periodo manual
        // typePeriodo = 1 -> hoje
        // typePeriodo = 2 -> esta semana
        // typePeriodo = 3 -> mes passado
        // typePeriodo = 4 -> este mes
        // typePeriodo = 5 -> proximo mes
        // typePeriodo = 6 -> este ano
        if (action.typePeriodo === undefined || action.typePeriodo === 0) {
          // Se vem do action.args, precisa converter se for objeto Date
          if (action.args.dataInicial && action.args.dataFinal) {
            // Se for objeto Date, converte para string YYYYMMDD
            if (action.args.dataInicial instanceof Date) {
              dataInicial = formatDateYYYYMMDD(action.args.dataInicial);
            } else {
              dataInicial = action.args.dataInicial;
            }

            if (action.args.dataFinal instanceof Date) {
              dataFinal = formatDateYYYYMMDD(action.args.dataFinal);
            } else {
              dataFinal = action.args.dataFinal;
            }
          } else {
            // Se não tem datas no action.args, usa as datas do filtro salvo
            dataInicial = filterSaved.dataInicial;
            dataFinal = filterSaved.dataFinal;
          }

          // Se ainda não tem datas, usa as datas do mês atual
          if (!dataInicial || !dataFinal) {
            dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), 1));
            dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 1, 0));
          }

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        } else if (action.typePeriodo === 1) {
          dataInicial = formatDateYYYYMMDD(new Date(date));
          dataFinal = formatDateYYYYMMDD(new Date(date));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        } else if (action.typePeriodo === 2) {
          const primeiro = date.getDate() - date.getDay();

          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), primeiro));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), primeiro + 6));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        } else if (action.typePeriodo === 3) {
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() - 1, 1));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), 0));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        } else if (action.typePeriodo === 4) {
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), 1));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 1, 0));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        } else if (action.typePeriodo === 5) {
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 1, 1));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 2, 0));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        } else if (action.typePeriodo === 6) {
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), 0, 1));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), 12, 0));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        }

        // Monta where baseado nos filtros
        where = '';
        if (action.args.tipoTransacao && action.args.tipoTransacao !== 'TODOS') {
          where = where + '&tipoTransacao=' + action.args.tipoTransacao;
        }

        newFilter = {
          ...newFilter,
          ...filterSaved, // Preserva dados do filtro salvo (incluindo contaBanco)
          ...action.args, // Sobrescreve com novos valores do action
          dataInicial,
          dataFinal,
          where: where,
          // Sempre resetar tipoTransacao para null, não persistir
          tipoTransacao: action.args.tipoTransacao || null
        };

        // Se veio conta bancária do action.args mas não tem no filterSaved, preserva a conta
        if (action.args.contaBanco && !filterSaved.contaBanco) {
          newFilter.contaBanco = action.args.contaBanco;
        }

      } else {
        // busca filtro salvo
        datas = formatDateDDMMYYYY(filterSaved.dataInicial) + '_' + formatDateDDMMYYYY(filterSaved.dataFinal);

        // Reconstroi where do filtro salvo - mas não usa tipoTransacao persistido
        where = '';
        // Não reconstroi tipoTransacao do filtro salvo, sempre inicia como null

        newFilter = {
          ...filterSaved,
          where: where,
          // Sempre resetar tipoTransacao para null ao carregar filtro salvo
          tipoTransacao: null
        };
      }
    }

    // Determina qual endpoint usar baseado na aba ativa
    const abaAtiva = newFilter.abaAtiva || 'pendentes';
    const endpointFunction = endpointMapping[abaAtiva];

    if (!endpointFunction) {
      throw new Error(`Endpoint não encontrado para a aba: ${abaAtiva}`);
    }

    // Busca registros usando o endpoint correto
    const filters = {
      contaBancoId: newFilter.contaBanco?.id ?? -1,
      dataInicio: newFilter.dataInicial,
      dataFim: newFilter.dataFinal
    };

    const whereParams = {
      tipoTransacao: newFilter.tipoTransacao,
      page: newFilter.page,
      size: newFilter.rows,
      historico: newFilter.historico
    };

    let list = yield call(endpointFunction, filters, whereParams);

    sessionStorage.setItem(CONST_FILTER_CONCILIACAO_BANCARIA, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_CONCILIACAO_BANCARIA_SUCCESS,
      list: list,
      filter: newFilter
    });

  } catch (error) {
    console.error('Erro na saga de conciliação bancária:', error);
    yield put({ type: NEW_FILTER_CONCILIACAO_BANCARIA_FAILURE });
  }
}

export default function* watchNewFilterConciliacaoBancaria() {
  yield takeLatest(NEW_FILTER_CONCILIACAO_BANCARIA, sagaNewFilterConciliacaoBancaria);
}